import React from 'react';
import ReactDOM from 'react-dom/client';
// Font Be Vietnam Pro tự host (thay Google Fonts): cùng domain nên không tốn thêm kết nối DNS/TLS tới
// fonts.googleapis.com + fonts.gstatic.com, file có hash nên cache lâu; unicode-range chỉ tải subset cần dùng
import '@fontsource/be-vietnam-pro/400.css';
import '@fontsource/be-vietnam-pro/500.css';
import '@fontsource/be-vietnam-pro/600.css';
import '@fontsource/be-vietnam-pro/700.css';
import '@fontsource/be-vietnam-pro/800.css';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
